import * as React from "react";
import { Landing } from "../billing/landing";
import { Navigate, useNavigate } from "react-router-dom";
import { useAppSelector } from "../../store/hooks";
import { selectHasAccount, selectHasOrg } from "../../store/userDataSlice";
import { Button } from "antd";

const NoOrgLanding: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="onboard-landing-page flex flex-col items-center">
      <div className="my-8 text-xl font-bold">Welcome to Control Plane</div>
      <div className="flex flex-col items-center justify-center gap-4">
        <div className="text-center">Create an Org to Get Started</div>
        <Button type="primary" className="action" onClick={() => navigate("/home/org/-create")}>
          Create Org
        </Button>
      </div>
    </div>
  );
};

export const HomeMain: React.FC = () => {
  const hasAccount = useAppSelector(selectHasAccount);
  const hasOrg = useAppSelector(selectHasOrg);

  if (!hasAccount) {
    return <Landing />;
  }

  if (hasOrg) {
    return <Navigate to={`/home/org`} />;
  }

  return <NoOrgLanding />;
};
